(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4861],{

/***/ 16116:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/travel-journal/[slug]",
      function () {
        return __webpack_require__(71695);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 61681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "qW": function() { return /* reexport */ black_membership; },
  "YZ": function() { return /* reexport */ black_plus_membership; },
  "Xs": function() { return /* reexport */ dynasty_dining_membership; },
  "b0": function() { return /* reexport */ dynasty_membership; },
  "s7": function() { return /* reexport */ gold_membership; },
  "CY": function() { return /* reexport */ partners_footer; },
  "Vo": function() { return /* reexport */ partners_header; },
  "Sm": function() { return /* reexport */ partners_header_2; },
  "YN": function() { return /* reexport */ travel_journal_hero; }
});

// UNUSED EXPORTS: silverMembershipPNG

;// CONCATENATED MODULE: ./assets/black_membership.png
/* harmony default export */ var black_membership = ({"src":"/_next/static/media/black_membership.89d63625.png","height":600,"width":880,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAADFBMVEUZGRlCQkEpKCU2NjbzRtKyAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIklEQVR4nB3IwQ0AMBDCMMPtv3NF87IiKUpyNMPWP4k1HB4DKgAhWfvXYwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./assets/black_plus_membership.png
/* harmony default export */ var black_plus_membership = ({"src":"/_next/static/media/black_plus_membership.0bde2d9f.png","height":600,"width":880,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAD1BMVEVEQ0IYGBgrKSYgHx82NjYEDsYOAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAJElEQVR4nC3JwQ0AMAyDQLCz/8yR0v7QAVQbgdFQgHy5+WLUBQRRAC3yPmMjAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./assets/gold_membership.png
/* harmony default export */ var gold_membership = ({"src":"/_next/static/media/gold_membership.87a9fcf4.png","height":600,"width":880,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAADFBMVEWkk3W4pYSvnoG9sZxpvOI1AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIElEQVR4nB3JwQ0AMBACIPT237mpPxIkUJLS+5iG5VA8AusAH7czvuEAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./assets/silver_membership.png
/* harmony default export */ var silver_membership = ({"src":"/_next/static/media/silver_membership.99059e53.png","height":600,"width":880,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAElBMVEXu7u7j4+Po6Ojd3d3Nzc2pqal7IW5rAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAJUlEQVR4nB3KwQ0AMAyDQHDc/Veukt9JAESnApi+WcTpAc2lvfwFEgAz4xAiVQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./assets/dynasty_membership.png
/* harmony default export */ var dynasty_membership = ({"src":"/_next/static/media/dynasty_membership.58020613.png","height":600,"width":880,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAADFBMVEX29fP+/v74+Pjs5toRryfmAAAAAXRSTlP+GuMHfQAAAAlwSFlzAAALEwAACxMBAJqcGAAAACFJREFUeJwtiUEOADAMQLD//3lp2hMBUiUq5cWZw51M1D4EngAzoU00MgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./assets/dynasty_dining_membership.png
/* harmony default export */ var dynasty_dining_membership = ({"src":"/_next/static/media/dynasty_dining_membership.d56ef584.png","height":600,"width":880,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAADFBMVEXx8fD+/v749/fs5trk6oFvAAAAAXRSTlP+GuMHfQAAAAlwSFlzAAALEwAACxMBAJqcGAAAACJJREFUeJwtybENACAMwLAk/P8zKmWzZEiVqLTzYQJPi8kLBOUANjWE7tYAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./assets/partners_header.png
/* harmony default export */ var partners_header = ({"src":"/_next/static/media/partners_header.754372d5.png","height":1078,"width":2560,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAMFBMVEWAhXZta12CobljcnRkXDZ1dnaMlpasyNWNp8J1b2hWUD2btcptkLecs7x+ho15ZUvbCLqIAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAI0lEQVR4nGPgZWfn5mBjYGZgYGNi4mFmYWHgYuVjZGTl5AcAB9YAldC+7G4AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./assets/partners_footer.png
/* harmony default export */ var partners_footer = ({"src":"/_next/static/media/partners_footer.5891e7bd.png","height":1020,"width":2560,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAIVBMVEWpo5+TlZjBwb+hoZ+Ad3SVioOfko2KiIaImKhXXm+tuszhlBAnAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAIklEQVR4nAXBgQEAIAjDsG6AQ/8/2IRxBE+Mi06Fu6s+5gME1QBgb0+aagAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./assets/partners-header-2.webp
/* harmony default export */ var partners_header_2 = ({"src":"/_next/static/media/partners-header-2.5037f2fa.webp","height":1078,"width":3300,"blurDataURL":"data:image/webp;base64,UklGRkYAAABXRUJQVlA4IDoAAAAQAgCdASoIAAMAAkA4JbACdLoAAwkaEd8AAP4JCVWu1nvgKeI907zXh1cUbnOP/B2Iec5Otnndp0AA","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./assets/travel-journal-hero.webp
/* harmony default export */ var travel_journal_hero = ({"src":"/_next/static/media/travel-journal-hero.851e428d.webp","height":563,"width":1920,"blurDataURL":"data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACwAQCdASoIAAIAAkA4JZwCdAEO/dXAAP6mz7c6epO1LQQoT94gygxSSdbqBoAA","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./assets/index.ts













/***/ }),

/***/ 96188:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* reexport */ InstagramCarrousel_InstagramCarrousel; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/ImageComponent/index.ts + 1 modules
var ImageComponent = __webpack_require__(87050);
// EXTERNAL MODULE: ./node_modules/zod/v3/types.js + 4 modules
var types = __webpack_require__(45901);
// EXTERNAL MODULE: ./blocks/Carrousel/InstagramCarrousel/InstagramCarrousel.module.css
var InstagramCarrousel_module = __webpack_require__(68714);
var InstagramCarrousel_module_default = /*#__PURE__*/__webpack_require__.n(InstagramCarrousel_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./blocks/Carrousel/InstagramCarrousel/InstagramCarrousel.tsx





var InstagramCarrousel = function(param) {
    var instagramData = param.instagramData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (InstagramCarrousel_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: "Instagram"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (InstagramCarrousel_module_default()).imageContainer,
                children: instagramData.slice(0, 4).map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: item.url,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            href: item.url,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            className: (InstagramCarrousel_module_default()).instagramPost,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (InstagramCarrousel_module_default()).instagramIcon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        width: "20",
                                        height: "20",
                                        viewBox: "0 0 20 20",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M9.99998 1.80184C12.6701 1.80184 12.9864 1.812 14.0408 1.86011C15.0158 1.90461 15.5453 2.06752 15.8977 2.20443C16.3644 2.38583 16.6976 2.60257 17.0475 2.95248C17.3974 3.30239 17.6142 3.63555 17.7955 4.10229C17.9325 4.4547 18.0954 4.98419 18.1399 5.95914C18.188 7.01364 18.1982 7.32989 18.1982 10C18.1982 12.6701 18.188 12.9864 18.1399 14.0409C18.0954 15.0158 17.9325 15.5453 17.7955 15.8978C17.6142 16.3645 17.3974 16.6976 17.0475 17.0476C16.6976 17.3975 16.3644 17.6142 15.8977 17.7956C15.5453 17.9325 15.0158 18.0954 14.0408 18.1399C12.9865 18.188 12.6703 18.1982 9.99998 18.1982C7.32969 18.1982 7.01344 18.188 5.95914 18.1399C4.98415 18.0954 4.45466 17.9325 4.10229 17.7956C3.63551 17.6142 3.30235 17.3975 2.95244 17.0476C2.60253 16.6976 2.38579 16.3645 2.20443 15.8978C2.06748 15.5453 1.90457 15.0158 1.86007 14.0409C1.81196 12.9864 1.8018 12.6701 1.8018 10C1.8018 7.32989 1.81196 7.01364 1.86007 5.95918C1.90457 4.98419 2.06748 4.4547 2.20443 4.10229C2.38579 3.63555 2.60253 3.30239 2.95244 2.95248C3.30235 2.60257 3.63551 2.38583 4.10229 2.20443C4.45466 2.06752 4.98415 1.90461 5.9591 1.86011C7.0136 1.812 7.32985 1.80184 9.99998 1.80184ZM9.99998 0C7.28412 0 6.94362 0.0115116 5.87701 0.0601777C4.81259 0.108764 4.08569 0.277786 3.44958 0.525007C2.79199 0.780564 2.23432 1.1225 1.67839 1.67843C1.12246 2.23436 0.780524 2.79203 0.524967 3.44962C0.277746 4.08573 0.108725 4.81263 0.060138 5.87705C0.0114719 6.94362 0 7.28416 0 10C0 12.7159 0.0114719 13.0564 0.060138 14.123C0.108725 15.1874 0.277746 15.9143 0.524967 16.5504C0.780524 17.208 1.12246 17.7657 1.67839 18.3216C2.23432 18.8775 2.79199 19.2195 3.44958 19.475C4.08569 19.7223 4.81259 19.8913 5.87701 19.9399C6.94362 19.9885 7.28412 20 9.99998 20C12.7158 20 13.0564 19.9885 14.1229 19.9399C15.1874 19.8913 15.9143 19.7223 16.5504 19.475C17.208 19.2195 17.7656 18.8775 18.3216 18.3216C18.8775 17.7657 19.2194 17.208 19.475 16.5504C19.7222 15.9143 19.8912 15.1874 19.9398 14.123C19.9885 13.0564 20 12.7159 20 10C20 7.28416 19.9885 6.94362 19.9398 5.87705C19.8912 4.81263 19.7222 4.08573 19.475 3.44962C19.2194 2.79203 18.8775 2.23436 18.3216 1.67843C17.7656 1.1225 17.208 0.780564 16.5504 0.525007C15.9143 0.277786 15.1874 0.108764 14.1229 0.0601777C13.0564 0.0115116 12.7158 0 9.99998 0ZM9.99998 4.86487C7.16393 4.86487 4.86483 7.16397 4.86483 10C4.86483 12.8361 7.16393 15.1352 9.99998 15.1352C12.836 15.1352 15.1351 12.8361 15.1351 10C15.1351 7.16397 12.836 4.86487 9.99998 4.86487ZM9.99998 13.3334C8.15904 13.3334 6.66663 11.841 6.66663 10C6.66663 8.15908 8.15904 6.66667 9.99998 6.66667C11.8409 6.66667 13.3333 8.15908 13.3333 10C13.3333 11.841 11.8409 13.3334 9.99998 13.3334ZM16.538 4.66199C16.538 5.32474 16.0008 5.86201 15.338 5.86201C14.6753 5.86201 14.138 5.32474 14.138 4.66199C14.138 3.99924 14.6753 3.462 15.338 3.462C16.0008 3.462 16.538 3.99924 16.538 4.66199Z",
                                            fill: "#F9F7F3"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageComponent/* Image */.E, {
                                    src: item.image,
                                    alt: "instagram post"
                                })
                            ]
                        })
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var InstagramCarrousel_InstagramCarrousel = (InstagramCarrousel);
// -----------------//
// type definitions //
// -----------------//
var InstagramCarrouselSchema = types/* object */.Ry({
    instagramData: types/* array */.IX(types/* object */.Ry({
        id: types/* string */.Z_(),
        image: types/* string */.Z_(),
        url: types/* string */.Z_().url()
    }))
});

;// CONCATENATED MODULE: ./blocks/Carrousel/index.ts



/***/ }),

/***/ 21569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ article_grid_ArticleGrid; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./blocks/travel-journal-articles/home/Articles.module.scss
var Articles_module = __webpack_require__(18427);
var Articles_module_default = /*#__PURE__*/__webpack_require__.n(Articles_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./blocks/travel-journal-articles/home/articles-card/full-background-img-article-card/FullBackgroundImgArticleCard.module.scss
var FullBackgroundImgArticleCard_module = __webpack_require__(96486);
var FullBackgroundImgArticleCard_module_default = /*#__PURE__*/__webpack_require__.n(FullBackgroundImgArticleCard_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/container/index.ts
var container = __webpack_require__(49985);
// EXTERNAL MODULE: ./components/text/index.ts
var components_text = __webpack_require__(22538);
;// CONCATENATED MODULE: ./blocks/travel-journal-articles/home/articles-card/full-background-img-article-card/FullBackgroundImgArticleCard.tsx






var FullBackgroundImgArticleCard = function(param) {
    var article = param.article;
    var title = article.title, header_image = article.header_image, introduction = article.introduction, categories = article.categories;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
        className: (FullBackgroundImgArticleCard_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
            className: (FullBackgroundImgArticleCard_module_default()).imageContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (FullBackgroundImgArticleCard_module_default()).cardHeader,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (FullBackgroundImgArticleCard_module_default()).categories,
                            children: categories === null || categories === void 0 ? void 0 : categories.map(function(category, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                                    color: "white",
                                    weight: "demiBold",
                                    children: category.name
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                            as: "h4",
                            color: "white",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (FullBackgroundImgArticleCard_module_default()).introduction,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                                color: "white",
                                fontSize: 18,
                                children: introduction
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: header_image,
                    layout: "fill",
                    objectPosition: "center",
                    objectFit: "cover",
                    alt: title,
                    sizes: "200vw"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
                    className: (FullBackgroundImgArticleCard_module_default()).bottomGradient
                })
            ]
        })
    });
};
/* harmony default export */ var full_background_img_article_card_FullBackgroundImgArticleCard = (FullBackgroundImgArticleCard);

;// CONCATENATED MODULE: ./blocks/travel-journal-articles/home/articles-card/full-background-img-article-card/index.ts


// EXTERNAL MODULE: ./blocks/travel-journal-articles/home/articles-card/article-card/ArticleCard.module.scss
var ArticleCard_module = __webpack_require__(16017);
var ArticleCard_module_default = /*#__PURE__*/__webpack_require__.n(ArticleCard_module);
;// CONCATENATED MODULE: ./blocks/travel-journal-articles/home/articles-card/article-card/ArticleCard.tsx






var ArticleCard = function(param) {
    var article = param.article;
    var title = article.title, introduction = article.introduction, header_image = article.header_image, categories = article.categories;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
        className: (ArticleCard_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
                className: (ArticleCard_module_default()).imageContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    priority: true,
                    src: header_image,
                    layout: "fill",
                    objectPosition: "center",
                    objectFit: "cover",
                    alt: title,
                    sizes: "(max-width: 768px) 100vw, (max-width: 1024px) 100vw, 640px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ArticleCard_module_default()).cardHeader,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ArticleCard_module_default()).categories,
                        children: categories === null || categories === void 0 ? void 0 : categories.map(function(category, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                                color: "gold-dark",
                                weight: "demiBold",
                                children: category.name
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                        as: "h4",
                        color: "grey-dark",
                        weight: "medium",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ArticleCard_module_default()).introduction,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                            color: "grey-dark",
                            fontSize: 18,
                            children: introduction
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var article_card_ArticleCard = (ArticleCard);

;// CONCATENATED MODULE: ./blocks/travel-journal-articles/home/articles-card/article-card/index.ts


// EXTERNAL MODULE: ./blocks/travel-journal-articles/home/article-link/index.ts + 1 modules
var article_link = __webpack_require__(3621);
;// CONCATENATED MODULE: ./blocks/travel-journal-articles/home/article-grid/ArticleGrid.tsx






var ArticleGrid = function(param) {
    var articles = param.articles, _showWide = param.showWide, showWide = _showWide === void 0 ? true : _showWide;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
        as: "section",
        className: "".concat((Articles_module_default()).articlesGrid, " ").concat(showWide ? (Articles_module_default()).showWide : ""),
        children: articles.map(function(article, index) {
            if (!article) return null;
            var CardComponent = showWide && [
                0,
                5
            ].includes(index) ? full_background_img_article_card_FullBackgroundImgArticleCard : article_card_ArticleCard;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(article_link/* default */.Z, {
                article: article,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardComponent, {
                    article: article
                })
            }, article.id);
        })
    });
};
/* harmony default export */ var article_grid_ArticleGrid = (ArticleGrid);


/***/ }),

/***/ 3621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ article_link_ArticleLink; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./blocks/travel-journal-articles/home/article-link/ArticleLink.tsx


var ArticleLink = function(param) {
    var article = param.article, children = param.children;
    var encodedSlug = encodeURIComponent(article.slug);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: "/travel-journal/".concat(encodedSlug),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                children: children
            })
        })
    }, article.id);
};
/* harmony default export */ var article_link_ArticleLink = (ArticleLink);

;// CONCATENATED MODULE: ./blocks/travel-journal-articles/home/article-link/index.ts



/***/ }),

/***/ 19096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);


var CategoryLink = function(param) {
    var category = param.category, children = param.children;
    var encodedSlug = encodeURIComponent(category.slug);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: "/travel-journal/".concat(encodedSlug),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            children: children
        })
    }, category.id);
};
/* harmony default export */ __webpack_exports__["Z"] = (CategoryLink);


/***/ }),

/***/ 26850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _CategoryLink__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _CategoryLink__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19096);



/***/ }),

/***/ 71695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./blocks/Layouts/GlobalLayout.tsx + 3 modules
var GlobalLayout = __webpack_require__(94082);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/text/index.ts
var components_text = __webpack_require__(22538);
// EXTERNAL MODULE: ./components/container/index.ts
var container = __webpack_require__(49985);
// EXTERNAL MODULE: ./blocks/travel-journal-articles/article/Article.module.scss
var Article_module = __webpack_require__(65499);
var Article_module_default = /*#__PURE__*/__webpack_require__.n(Article_module);
// EXTERNAL MODULE: ./data/constants.ts
var constants = __webpack_require__(84749);
;// CONCATENATED MODULE: ./blocks/travel-journal-articles/article/utils.ts

var getHotelPageLink = function(hotelId, link) {
    if (hotelId === null) {
        return link; // replace with a default link
    }
    // Replace all occurrences of :id with the hotelId
    return constants/* navigationPaths.HOTEL_PAGE_INTERNAL.replace */.aY.HOTEL_PAGE_INTERNAL.replace(/:id/g, String(hotelId));
};

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./blocks/travel-journal-articles/article/content-blocks/image-block/ImageBlock.module.scss
var ImageBlock_module = __webpack_require__(35016);
var ImageBlock_module_default = /*#__PURE__*/__webpack_require__.n(ImageBlock_module);
;// CONCATENATED MODULE: ./blocks/travel-journal-articles/article/content-blocks/image-block/ImageBlock.tsx







var ImageBlock = function(param) {
    var block = param.block, hotelPageLink = param.hotelPageLink;
    var image = block.image, description = block.description, caption = block.caption;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
        className: caption ? (ImageBlock_module_default()).imageBlockCaption : (ImageBlock_module_default()).imageBlockButton,
        children: [
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
                className: (ImageBlock_module_default()).imageBlock,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: hotelPageLink,
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: image,
                            layout: "fill",
                            objectPosition: "center",
                            objectFit: "cover",
                            alt: description,
                            sizes: "(max-width: 1024px) 200vw, 1920px"
                        })
                    })
                })
            }),
            caption && /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Small */.x4, {
                    color: "grey-dark",
                    children: caption
                })
            })
        ]
    });
};
/* harmony default export */ var image_block_ImageBlock = (ImageBlock);

;// CONCATENATED MODULE: ./blocks/travel-journal-articles/article/content-blocks/image-block/index.ts


// EXTERNAL MODULE: ./blocks/travel-journal-articles/article/content-blocks/parsed-text-block/ParsedTextBlock.module.scss
var ParsedTextBlock_module = __webpack_require__(91145);
var ParsedTextBlock_module_default = /*#__PURE__*/__webpack_require__.n(ParsedTextBlock_module);
// EXTERNAL MODULE: ./node_modules/html-react-parser/esm/index.mjs
var esm = __webpack_require__(47311);
;// CONCATENATED MODULE: ./blocks/travel-journal-articles/article/parseText.tsx



var parseText = function(text) {
    return (0,esm/* default */.ZP)(text, {
        replace: function(domNode) {
            if (domNode.name === "a") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: domNode.attribs.href,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: (0,esm/* domToReact */.du)(Array.from(domNode.children))
                });
            }
            // Logic for headings
            if (/^h[1-6]$/.test(domNode.name)) {
                var style = {
                    marginBottom: "20px"
                }; // Adjust the value for headings as needed
                return /*#__PURE__*/ react.createElement(domNode.name, {
                    style: style
                }, (0,esm/* domToReact */.du)(Array.from(domNode.children)));
            }
        }
    });
};

;// CONCATENATED MODULE: ./blocks/travel-journal-articles/article/content-blocks/parsed-text-block/ParsedTextBlock.tsx



var ParsedTextBlock = function(param) {
    var block = param.block;
    var text = block.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ParsedTextBlock_module_default()).blockText,
        children: text && parseText(text)
    });
};
/* harmony default export */ var parsed_text_block_ParsedTextBlock = (ParsedTextBlock);

;// CONCATENATED MODULE: ./blocks/travel-journal-articles/article/content-blocks/parsed-text-block/index.ts


// EXTERNAL MODULE: ./blocks/travel-journal-articles/article/content-blocks/ContentBlocks.module.scss
var ContentBlocks_module = __webpack_require__(28560);
var ContentBlocks_module_default = /*#__PURE__*/__webpack_require__.n(ContentBlocks_module);
;// CONCATENATED MODULE: ./blocks/travel-journal-articles/article/content-blocks/ContentBlocks.tsx






var ContentBlocks = function(param) {
    var blocks = param.blocks;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: blocks.map(function(block, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ContentBlocks_module_default()).container,
                children: [
                    block.image && /*#__PURE__*/ (0,jsx_runtime.jsx)(image_block_ImageBlock, {
                        block: block,
                        hotelPageLink: getHotelPageLink(block.hotel_id, block.link)
                    }),
                    block.text && /*#__PURE__*/ (0,jsx_runtime.jsx)(parsed_text_block_ParsedTextBlock, {
                        block: block
                    })
                ]
            }, index);
        })
    });
};
/* harmony default export */ var content_blocks_ContentBlocks = (ContentBlocks);

;// CONCATENATED MODULE: ./blocks/travel-journal-articles/article/content-blocks/index.ts


// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./blocks/travel-journal-articles/article/article-meta-data/ArticleMetaData.module.scss
var ArticleMetaData_module = __webpack_require__(9184);
var ArticleMetaData_module_default = /*#__PURE__*/__webpack_require__.n(ArticleMetaData_module);
// EXTERNAL MODULE: ./blocks/travel-journal-articles/article/article-info-item/ArticleInfoItem.module.scss
var ArticleInfoItem_module = __webpack_require__(10392);
var ArticleInfoItem_module_default = /*#__PURE__*/__webpack_require__.n(ArticleInfoItem_module);
;// CONCATENATED MODULE: ./blocks/travel-journal-articles/article/article-info-item/ArticleInfoItem.tsx




var ArticleInfoItem = function(param) {
    var detail = param.detail, _showEllipse = param.showEllipse, showEllipse = _showEllipse === void 0 ? true : _showEllipse;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            showEllipse && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ArticleInfoItem_module_default()).ellipse
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                color: "grey-dark",
                children: detail
            })
        ]
    });
};
/* harmony default export */ var article_info_item_ArticleInfoItem = (ArticleInfoItem);

;// CONCATENATED MODULE: ./blocks/travel-journal-articles/article/article-info-item/index.ts


// EXTERNAL MODULE: ./blocks/travel-journal-articles/article/sharing-items/SharingItems.module.scss
var SharingItems_module = __webpack_require__(96348);
var SharingItems_module_default = /*#__PURE__*/__webpack_require__.n(SharingItems_module);
// EXTERNAL MODULE: ./components/icons/index.ts + 18 modules
var icons = __webpack_require__(30918);
;// CONCATENATED MODULE: ./blocks/travel-journal-articles/article/sharing-items/SharingItems.tsx




var SharingItems = function(param) {
    var facebookShareUrl = param.facebookShareUrl, emailShareUrl = param.emailShareUrl, whatsappShareUrl = param.whatsappShareUrl, linkedinShareUrl = param.linkedinShareUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (SharingItems_module_default()).sharingItems,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: linkedinShareUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                "aria-label": "Share on Linkedin",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* LinkedinIcon */.pA, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: facebookShareUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                "aria-label": "Share on Facebook",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* FacebookIcon */.Vq, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: emailShareUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                "aria-label": "Share via Email",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EmailIcon */.LQ, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: whatsappShareUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                "aria-label": "Share on WhatsApp",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* WhatsappGoldDarkIcon */.j4, {})
            })
        ]
    });
};
/* harmony default export */ var sharing_items_SharingItems = (SharingItems);

;// CONCATENATED MODULE: ./blocks/travel-journal-articles/article/sharing-items/index.ts


;// CONCATENATED MODULE: ./utils/sendEmail.ts
var sendEmail = function(EmailInfo) {
    var to = EmailInfo.to, subject = EmailInfo.subject, body = EmailInfo.body;
    var url = new URL("mailto:".concat(to));
    var params = new URLSearchParams({
        subject: subject,
        body: body
    });
    url.search = params.toString().replace(/\+/g, "%20");
    return url.href;
};

;// CONCATENATED MODULE: ./utils/handleSendEmail.ts

var handleSendEmail = function(title, subheading, articleUrl) {
    var to = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    var subject = "".concat(title, " | Little Emperors ");
    var bodyLines = [
        "I thought you might be interested in this article from the Little Emperors Travel Journal:",
        title,
        subheading,
        "",
        "Read more here: ".concat(articleUrl), 
    ];
    var body = bodyLines.join("\n");
    return sendEmail({
        to: to,
        subject: subject,
        body: body
    });
};

;// CONCATENATED MODULE: ./blocks/travel-journal-articles/article/article-meta-data/ArticleMetaData.tsx







var ArticleMetaData = function(param) {
    var article = param.article;
    var title = article.title, subheading = article.subheading, author = article.author, read_time = article.read_time, date = article.date, header_image = article.header_image;
    var formattedArticleDate = moment_default()(date).format("D MMMM YYYY");
    var articleUrlRef = (0,react.useRef)("");
    articleUrlRef.current =  true ? window.location.href : 0;
    var ref = (0,react.useState)(false), isClient = ref[0], setIsClient = ref[1];
    // Empty useEffect hook that runs once after the initial render.
    // This is used to set the isClient state variable to true, indicating that the component is now being rendered on the client side.
    // This is necessary because certain values (like articleUrlRef.current) are only available on the client side.
    (0,react.useEffect)(function() {
        setIsClient(true);
    }, []);
    // If the component is not being rendered on the client side, or if articleUrlRef.current is not defined,
    // the component returns null. This prevents the component from being rendered until both conditions are met.
    // This is necessary to avoid a "Prop `href` did not match" warning, which can occur when a value changes between the server and client renders.
    if (!isClient || !articleUrlRef.current) {
        return null;
    }
    var message = encodeURIComponent("Check out this article: ".concat(articleUrlRef.current));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (ArticleMetaData_module_default()).lineContent,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ArticleMetaData_module_default()).articleInfoItems,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(article_info_item_ArticleInfoItem, {
                            detail: formattedArticleDate,
                            showEllipse: false
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(article_info_item_ArticleInfoItem, {
                            detail: author
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(article_info_item_ArticleInfoItem, {
                            detail: "".concat(read_time, " min read")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(sharing_items_SharingItems, {
                    linkedinShareUrl: "https://www.linkedin.com/sharing/share-offsite/?url=".concat(encodeURIComponent(articleUrlRef.current)),
                    facebookShareUrl: "https://www.facebook.com/sharer/sharer.php?u=".concat(encodeURIComponent(articleUrlRef.current)),
                    emailShareUrl: handleSendEmail(title, subheading, articleUrlRef.current),
                    whatsappShareUrl: "https://wa.me/?text=".concat(message)
                })
            ]
        })
    });
};
/* harmony default export */ var article_meta_data_ArticleMetaData = (ArticleMetaData);

;// CONCATENATED MODULE: ./blocks/travel-journal-articles/article/article-meta-data/index.ts


// EXTERNAL MODULE: ./blocks/travel-journal-articles/article/header-hero/HeaderHero.module.scss
var HeaderHero_module = __webpack_require__(28877);
var HeaderHero_module_default = /*#__PURE__*/__webpack_require__.n(HeaderHero_module);
;// CONCATENATED MODULE: ./blocks/travel-journal-articles/article/header-hero/HeaderHero.tsx







var HeaderHero = function(param) {
    var hotelPageLink = param.hotelPageLink, headerImage = param.headerImage;
    var image = headerImage.image, description = headerImage.description, caption = headerImage.caption;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
        as: "header",
        className: (HeaderHero_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
                className: (HeaderHero_module_default()).imageContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: hotelPageLink,
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: image,
                            layout: "fill",
                            objectPosition: "center",
                            objectFit: "cover",
                            alt: description,
                            sizes: "200vw"
                        })
                    })
                })
            }),
            caption && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (HeaderHero_module_default()).caption,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Small */.x4, {
                    color: "grey-dark",
                    children: caption
                })
            })
        ]
    });
};
/* harmony default export */ var header_hero_HeaderHero = (HeaderHero);

;// CONCATENATED MODULE: ./blocks/travel-journal-articles/article/header-hero/index.ts


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./assets/svg/arrow-right.svg
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

const SvgArrowRight = props => /*#__PURE__*/react.createElement("svg", _extends({
  width: 10,
  height: 18,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  d: "M2.514 3 2 3.563 6.971 9 2 14.438l.514.562L8 9 2.514 3Z",
  fill: "#191919"
})));
/* harmony default export */ var arrow_right = (SvgArrowRight);
// EXTERNAL MODULE: ./components/breadcrumbs/Crumb.module.scss
var Crumb_module = __webpack_require__(4547);
var Crumb_module_default = /*#__PURE__*/__webpack_require__.n(Crumb_module);
;// CONCATENATED MODULE: ./components/breadcrumbs/Crumb.tsx









var Crumb = function(_param) {
    var route = _param.route, isActive = _param.isActive, showArrow = _param.showArrow, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "route",
        "isActive",
        "showArrow"
    ]);
    var containerClass = classnames_default()((Crumb_module_default()).container, (0,_define_property/* default */.Z)({}, (Crumb_module_default()).active, isActive));
    var arrowClass = classnames_default()((Crumb_module_default()).arrow, (0,_define_property/* default */.Z)({}, (Crumb_module_default()).active, isActive));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            showArrow && /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right, {
                className: arrowClass
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: containerClass,
                children: route.href ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: route.href,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
                        children: route.name
                    }))
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
                    children: route.name
                }))
            })
        ]
    });
};
/* harmony default export */ var breadcrumbs_Crumb = (Crumb);

;// CONCATENATED MODULE: ./components/breadcrumbs/utils.ts
var deSlugify = function(string) {
    return string.replace(/-/g, " ").replace(/_/g, "");
};
var titleCase = function(string) {
    return string.split(" ").map(function(word) {
        return word[0].toUpperCase() + word.slice(1);
    }).join(" ");
};

// EXTERNAL MODULE: ./components/breadcrumbs/Breadcrumbs.module.scss
var Breadcrumbs_module = __webpack_require__(91490);
var Breadcrumbs_module_default = /*#__PURE__*/__webpack_require__.n(Breadcrumbs_module);
;// CONCATENATED MODULE: ./components/breadcrumbs/Breadcrumbs.tsx







var Breadcrumbs = function(param) {
    var setRouteList = param.setRouteList;
    var router = (0,next_router.useRouter)();
    var routeList = (0,react.useMemo)(function() {
        if (router.pathname === "/") {
            return [];
        }
        var ref = (0,_sliced_to_array/* default */.Z)(router.asPath.split("?"), 1), pathWithoutQuery = ref[0];
        var linkPath = pathWithoutQuery.split("/");
        var list = linkPath.map(function(route, index) {
            if (route === "") {
                return {
                    href: "/",
                    name: "Home"
                };
            }
            return {
                href: linkPath.slice(0, index + 1).join("/").replace(/(\?|#).*/, ""),
                name: titleCase(deSlugify(route))
            };
        });
        return setRouteList ? setRouteList(list) : list;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        setRouteList
    ]);
    if (!routeList.length) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        "aria-label": "Breadcrumb",
        className: (Breadcrumbs_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
            children: routeList.map(function(route, index) {
                var isLast = index === routeList.length - 1;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumbs_Crumb, {
                    route: route,
                    isActive: isLast,
                    "aria-current": isLast ? "page" : undefined,
                    showArrow: index !== 0
                }, index);
            })
        })
    });
};
/* harmony default export */ var breadcrumbs_Breadcrumbs = (Breadcrumbs);

;// CONCATENATED MODULE: ./components/breadcrumbs/index.ts


;// CONCATENATED MODULE: ./blocks/travel-journal-articles/article/Article.tsx











var Article = function(param) {
    var article = param.article;
    var title = article.title, subheading = article.subheading, header_image = article.header_image, intro_paragraph = article.intro_paragraph, content_blocks = article.content_blocks, categories = article.categories;
    var primaryCategory = article.categories[0];
    var hotel_id = header_image.hotel_id, link = header_image.link;
    var hotelPageLink = getHotelPageLink(hotel_id, link);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_hero_HeaderHero, {
                hotelPageLink: hotelPageLink,
                headerImage: header_image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
                as: "article",
                className: (Article_module_default()).contentContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: (Article_module_default()).backButton,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumbs_Breadcrumbs, {
                            setRouteList: function() {
                                return [
                                    {
                                        name: "Travel Journal",
                                        href: "/travel-journal"
                                    },
                                    {
                                        name: primaryCategory.name,
                                        href: "/travel-journal/".concat(primaryCategory.slug)
                                    },
                                    {
                                        name: title,
                                        href: ""
                                    }, 
                                ];
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
                        className: (Article_module_default()).content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Article_module_default()).categories,
                                children: categories.map(function(category, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                                        color: "gold-dark",
                                        weight: "demiBold",
                                        fontSize: 18,
                                        children: category.name
                                    }, index);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                                as: "h1",
                                color: "black",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Article_module_default()).subContent,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Article_module_default()).subheading,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                                            as: "h5",
                                            color: "grey-dark",
                                            children: subheading
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(article_meta_data_ArticleMetaData, {
                                        article: article
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Article_module_default()).introParagraph,
                                        children: parseText(intro_paragraph)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(content_blocks_ContentBlocks, {
                                blocks: content_blocks
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var article_Article = (Article);

;// CONCATENATED MODULE: ./blocks/travel-journal-articles/article/index.ts


// EXTERNAL MODULE: ./blocks/Carrousel/index.ts + 1 modules
var Carrousel = __webpack_require__(96188);
// EXTERNAL MODULE: ./blocks/travel-journal-articles/category/Category.module.scss
var Category_module = __webpack_require__(28735);
var Category_module_default = /*#__PURE__*/__webpack_require__.n(Category_module);
// EXTERNAL MODULE: ./blocks/travel-journal-articles/home/hero-section/HeroSection.module.scss
var HeroSection_module = __webpack_require__(98537);
var HeroSection_module_default = /*#__PURE__*/__webpack_require__.n(HeroSection_module);
// EXTERNAL MODULE: ./assets/index.ts + 10 modules
var assets = __webpack_require__(61681);
// EXTERNAL MODULE: ./blocks/travel-journal-articles/home/category-link/index.ts
var category_link = __webpack_require__(26850);
;// CONCATENATED MODULE: ./blocks/travel-journal-articles/category/hero-section/HeroSection.tsx






var HeroSection = function(param) {
    var selectedCategory = param.selectedCategory, categories = param.categories;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
        as: "header",
        className: (HeroSection_module_default()).heroSection,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: (HeroSection_module_default()).title,
                children: selectedCategory.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: selectedCategory.image || assets/* travelJournalHeroWEBP */.YN,
                objectPosition: "center",
                objectFit: "cover",
                alt: "Travel Journal | ".concat(selectedCategory.name),
                layout: "fill",
                sizes: "200vw"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                className: (HeroSection_module_default()).categories,
                children: categories.map(function(category) {
                    return category.slug === selectedCategory.slug ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HeroSection_module_default()).active,
                        children: category.name
                    }, category.id) : /*#__PURE__*/ (0,jsx_runtime.jsx)(category_link/* default */.Z, {
                        category: category,
                        children: category.name
                    }, category.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
                className: (HeroSection_module_default()).bottomGradient
            })
        ]
    });
};
/* harmony default export */ var hero_section_HeroSection = (HeroSection);

;// CONCATENATED MODULE: ./blocks/travel-journal-articles/category/hero-section/index.ts


// EXTERNAL MODULE: ./blocks/travel-journal-articles/category/popular-article-card/PopularArticleCard.module.scss
var PopularArticleCard_module = __webpack_require__(32103);
var PopularArticleCard_module_default = /*#__PURE__*/__webpack_require__.n(PopularArticleCard_module);
;// CONCATENATED MODULE: ./assets/svg/arrow-long-right.svg
var arrow_long_right_path;
function arrow_long_right_extends() { return arrow_long_right_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, arrow_long_right_extends.apply(null, arguments); }

const SvgArrowLongRight = props => /*#__PURE__*/react.createElement("svg", arrow_long_right_extends({
  width: 38,
  height: 9,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), arrow_long_right_path || (arrow_long_right_path = /*#__PURE__*/react.createElement("path", {
  d: "M37.354 4.854a.5.5 0 0 0 0-.708L34.172.964a.5.5 0 1 0-.707.708L36.293 4.5l-2.828 2.828a.5.5 0 1 0 .707.708l3.182-3.182ZM0 5h37V4H0v1Z",
  fill: "#BAA57E"
})));
/* harmony default export */ var arrow_long_right = (SvgArrowLongRight);
// EXTERNAL MODULE: ./blocks/travel-journal-articles/home/article-link/index.ts + 1 modules
var article_link = __webpack_require__(3621);
// EXTERNAL MODULE: ./blocks/travel-journal-articles/home/category-link/CategoryLink.tsx
var CategoryLink = __webpack_require__(19096);
;// CONCATENATED MODULE: ./blocks/travel-journal-articles/category/popular-article-card/PopularArticleCard.tsx









var PopularArticleCard = function(param) {
    var article = param.article;
    var title = article.title, introduction = article.introduction, header_image = article.header_image, categories = article.categories;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
        as: "article",
        className: (PopularArticleCard_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
                className: (PopularArticleCard_module_default()).imageContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(article_link/* default */.Z, {
                    article: article,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        priority: true,
                        src: header_image,
                        layout: "fill",
                        objectPosition: "center",
                        objectFit: "cover",
                        alt: title,
                        sizes: "(max-width: 768px) 200vw, (max-width: 1024px) 100vw, 40vw"
                    })
                }, article.id)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (PopularArticleCard_module_default()).cardHeader,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (PopularArticleCard_module_default()).cardHeaderTop,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (PopularArticleCard_module_default()).categories,
                                children: categories === null || categories === void 0 ? void 0 : categories.map(function(category, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryLink/* default */.Z, {
                                        category: category,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                                            color: "gold-dark",
                                            weight: "demiBold",
                                            children: category.name
                                        }, index)
                                    }, index);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(article_link/* default */.Z, {
                                article: article,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                                    as: "h4",
                                    color: "grey-dark",
                                    weight: "medium",
                                    children: title
                                })
                            }, article.id),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (PopularArticleCard_module_default()).introduction,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                                    color: "grey-dark",
                                    fontSize: 18,
                                    children: introduction
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(article_link/* default */.Z, {
                        article: article,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (PopularArticleCard_module_default()).arrow,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_long_right, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                                    color: "gold-dark",
                                    weight: "demiBold",
                                    children: "Read more"
                                })
                            ]
                        })
                    }, article.id)
                ]
            })
        ]
    });
};
/* harmony default export */ var popular_article_card_PopularArticleCard = (PopularArticleCard);

;// CONCATENATED MODULE: ./blocks/travel-journal-articles/category/popular-article-card/index.ts


// EXTERNAL MODULE: ./blocks/travel-journal-articles/category/popular-articles/PopularArticles.module.scss
var PopularArticles_module = __webpack_require__(61969);
var PopularArticles_module_default = /*#__PURE__*/__webpack_require__.n(PopularArticles_module);
;// CONCATENATED MODULE: ./blocks/travel-journal-articles/category/popular-articles/PopularArticles.tsx






var PopularArticles = function(param) {
    var articles = param.articles;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
        as: "section",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                as: "h2",
                fontSize: 28,
                className: (PopularArticles_module_default()).title,
                children: "Popular this month"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PopularArticles_module_default()).articlesGrid,
                children: articles.map(function(article) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(popular_article_card_PopularArticleCard, {
                        article: article
                    }, article.id);
                })
            })
        ]
    });
};
/* harmony default export */ var popular_articles_PopularArticles = (PopularArticles);

;// CONCATENATED MODULE: ./blocks/travel-journal-articles/category/popular-articles/index.ts


// EXTERNAL MODULE: ./blocks/travel-journal-articles/category/featured-article/FeaturedArticle.module.scss
var FeaturedArticle_module = __webpack_require__(99575);
var FeaturedArticle_module_default = /*#__PURE__*/__webpack_require__.n(FeaturedArticle_module);
;// CONCATENATED MODULE: ./blocks/travel-journal-articles/category/featured-article/FeaturedArticle.tsx









var FeaturedArticle = function(param) {
    var article = param.article;
    if (!article) {
        return null;
    }
    var header_image = article.header_image, categories = article.categories;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
        as: "article",
        className: (FeaturedArticle_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (FeaturedArticle_module_default()).containerInner,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (FeaturedArticle_module_default()).cardHeader,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (FeaturedArticle_module_default()).cardHeaderTop,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (FeaturedArticle_module_default()).categories,
                                    children: categories === null || categories === void 0 ? void 0 : categories.map(function(category, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryLink/* default */.Z, {
                                            category: category,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                                                color: "gold-dark",
                                                weight: "demiBold",
                                                children: category.name
                                            })
                                        }, index);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(article_link/* default */.Z, {
                                    article: article,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                                        as: "h4",
                                        color: "grey-dark",
                                        weight: "medium",
                                        children: article.title
                                    })
                                }, article.id)
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (FeaturedArticle_module_default()).introduction,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                                    color: "grey-dark",
                                    fontSize: 18,
                                    children: article.introduction
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(article_link/* default */.Z, {
                                    article: article,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (FeaturedArticle_module_default()).arrow,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_long_right, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                                                color: "gold-dark",
                                                weight: "demiBold",
                                                children: "Read more"
                                            })
                                        ]
                                    })
                                }, article.id)
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (FeaturedArticle_module_default()).imageContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(article_link/* default */.Z, {
                        article: article,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: header_image,
                            layout: "fill",
                            objectPosition: "center",
                            objectFit: "cover",
                            alt: article.title,
                            sizes: "(max-width: 1024px) 200vw, 1920px"
                        })
                    }, article.id)
                })
            ]
        })
    });
};
/* harmony default export */ var featured_article_FeaturedArticle = (FeaturedArticle);

;// CONCATENATED MODULE: ./blocks/travel-journal-articles/category/featured-article/index.ts


// EXTERNAL MODULE: ./blocks/travel-journal-articles/home/article-grid/ArticleGrid.tsx + 4 modules
var ArticleGrid = __webpack_require__(21569);
;// CONCATENATED MODULE: ./blocks/travel-journal-articles/category/Category.tsx









var Category = function(param) {
    var category = param.category, categories = param.categories;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(hero_section_HeroSection, {
                categories: categories,
                selectedCategory: category
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Category_module_default()).container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Category_module_default()).containerInner,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                className: (Category_module_default()).breadCrumbContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumbs_Breadcrumbs, {
                                    setRouteList: function() {
                                        return [
                                            {
                                                name: "Travel Journal",
                                                href: "/travel-journal"
                                            },
                                            {
                                                name: category.name,
                                                href: "/travel-journal/".concat(category.slug)
                                            }, 
                                        ];
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(popular_articles_PopularArticles, {
                                articles: category.articles.slice(0, 3)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(featured_article_FeaturedArticle, {
                        article: category.articles[3]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                        as: "h3",
                        fontSize: 28,
                        className: (Category_module_default()).readMore,
                        children: "Read next"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleGrid/* default */.Z, {
                        articles: category.articles.slice(4, 10),
                        showWide: false
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var category_Category = (Category);

;// CONCATENATED MODULE: ./blocks/travel-journal-articles/category/index.ts


;// CONCATENATED MODULE: ./pages/travel-journal/[slug].tsx








var ArticlePage = function(param) {
    var globalLayoutProps = param.globalLayoutProps, article = param.article, instagram = param.instagram, category = param.category, categories = param.categories, isCategory = param.isCategory, articles = param.articles;
    var router = (0,next_router.useRouter)();
    if (router.isFallback) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "Loading..."
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalLayout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, globalLayoutProps), {
        children: isCategory ? /*#__PURE__*/ (0,jsx_runtime.jsx)(category_Category, {
            category: category,
            categories: categories,
            articles: articles
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(article_Article, {
                    article: article
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "outOfBounds",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Carrousel/* InstagramCarrousel */.O, {
                        instagramData: instagram
                    })
                })
            ]
        })
    }));
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (ArticlePage);


/***/ }),

/***/ 68714:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"InstagramCarrousel_container__c2Df_","imageContainer":"InstagramCarrousel_imageContainer__ekEaT","instagramPost":"InstagramCarrousel_instagramPost__e76QY","instagramIcon":"InstagramCarrousel_instagramIcon__G4D32"};

/***/ }),

/***/ 65499:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"Article_contentContainer__zSt7E","backButton":"Article_backButton__3yQgd","content":"Article_content__YzYCj","subheading":"Article_subheading__Aogbq","subContent":"Article_subContent__z0gCH","introParagraph":"Article_introParagraph__XJOb_","categories":"Article_categories__x1PZY"};

/***/ }),

/***/ 10392:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ellipse":"ArticleInfoItem_ellipse__VT_RJ"};

/***/ }),

/***/ 9184:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"lineContent":"ArticleMetaData_lineContent__Ejz30","articleInfoItems":"ArticleMetaData_articleInfoItems__1tp1Q"};

/***/ }),

/***/ 28560:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"ContentBlocks_container__JqVGO"};

/***/ }),

/***/ 35016:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imageBlockButton":"ImageBlock_imageBlockButton__PL6HT","imageBlock":"ImageBlock_imageBlock__DOibi","imageBlockCaption":"ImageBlock_imageBlockCaption__t8wbB"};

/***/ }),

/***/ 91145:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"blockText":"ParsedTextBlock_blockText__fKM_5"};

/***/ }),

/***/ 28877:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HeaderHero_wrapper__5nReO","imageContainer":"HeaderHero_imageContainer__wAqXd","caption":"HeaderHero_caption__dgHIA"};

/***/ }),

/***/ 96348:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sharingItems":"SharingItems_sharingItems__PFS78"};

/***/ }),

/***/ 28735:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Category_container__Wclx3","containerInner":"Category_containerInner__84t46","breadCrumbContainer":"Category_breadCrumbContainer__Ws5QF","content":"Category_content__DK4zL","categories":"Category_categories__fSdV9","readMore":"Category_readMore__VptRR"};

/***/ }),

/***/ 99575:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"FeaturedArticle_container__Y_Scu","containerInner":"FeaturedArticle_containerInner__lOpiq","imageContainer":"FeaturedArticle_imageContainer__xS4r6","cardHeader":"FeaturedArticle_cardHeader__SwwJ1","cardHeaderTop":"FeaturedArticle_cardHeaderTop__TZNR_","introduction":"FeaturedArticle_introduction__pnY8F","categories":"FeaturedArticle_categories__S0O63","arrow":"FeaturedArticle_arrow__B8__b"};

/***/ }),

/***/ 32103:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"PopularArticleCard_container__Ujk__","imageContainer":"PopularArticleCard_imageContainer__RSbhQ","cardHeader":"PopularArticleCard_cardHeader__4F6H1","cardHeaderTop":"PopularArticleCard_cardHeaderTop__HL5d9","categories":"PopularArticleCard_categories__q2EZr","arrow":"PopularArticleCard_arrow__Ny2pQ"};

/***/ }),

/***/ 61969:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"PopularArticles_title__TQgtk","articlesGrid":"PopularArticles_articlesGrid__4p8e5"};

/***/ }),

/***/ 18427:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"articlesGrid":"Articles_articlesGrid__0kbS2","showWide":"Articles_showWide__ja9v3"};

/***/ }),

/***/ 16017:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"ArticleCard_container__wb7vV","imageContainer":"ArticleCard_imageContainer__HTlUa","cardHeader":"ArticleCard_cardHeader__Bgt6y","categories":"ArticleCard_categories__K0RzG"};

/***/ }),

/***/ 96486:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"FullBackgroundImgArticleCard_container__mlaUR","imageContainer":"FullBackgroundImgArticleCard_imageContainer__JJueg","bottomGradient":"FullBackgroundImgArticleCard_bottomGradient__Vz2d4","cardHeader":"FullBackgroundImgArticleCard_cardHeader__MUgEW","categories":"FullBackgroundImgArticleCard_categories___xMEK","content":"FullBackgroundImgArticleCard_content__TfdJE","introduction":"FullBackgroundImgArticleCard_introduction__AGT3I"};

/***/ }),

/***/ 98537:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heroSection":"HeroSection_heroSection__yuBFJ","title":"HeroSection_title__wjL5O","categories":"HeroSection_categories__QDUyp","active":"HeroSection_active__q_iOm","bottomGradient":"HeroSection_bottomGradient__h70qh"};

/***/ }),

/***/ 91490:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Breadcrumbs_container__LhDIu","arrow":"Breadcrumbs_arrow__0CZ5t","active":"Breadcrumbs_active__MU0lF"};

/***/ }),

/***/ 4547:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Crumb_container__GKvnB","active":"Crumb_active__pKmRW","arrow":"Crumb_arrow__VO_j_"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7295,5675,5901,1608,7311,4520,5989,2394,9774,2888,179], function() { return __webpack_exec__(16116); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);